'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Share = require('./Share');

var _Share2 = _interopRequireDefault(_Share);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ShareButton, _Component);

  function ShareButton() {
    (0, _classCallCheck3.default)(this, ShareButton);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  ShareButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        iconClassName = _props.iconClassName,
        icon = _props.icon,
        children = _props.children;
    var _props2 = this.props,
        width = _props2.width,
        href = _props2.href,
        height = _props2.height,
        hashtag = _props2.hashtag,
        quote = _props2.quote,
        mobileIframe = _props2.mobileIframe,
        display = _props2.display,
        appId = _props2.appId,
        redirectURI = _props2.redirectURI;


    return _react2.default.createElement(
      _Share2.default,
      {
        href: href,
        width: width,
        height: height,
        hashtag: hashtag,
        quote: quote,
        mobileIframe: mobileIframe,
        display: display,
        appId: appId,
        redirectURI: redirectURI
      },
      _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: className
        },
        !!icon && _react2.default.createElement('i', { className: iconClassName }),
        children
      )
    );
  };

  return ShareButton;
}(_react.Component), _class.propTypes = (0, _extends3.default)({}, _Share2.default.propTypes, {
  className: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  icon: _propTypes2.default.bool
}), _class.defaultProps = (0, _extends3.default)({}, _Share2.default.defaultProps, {
  className: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  icon: true
}), _temp);
exports.default = ShareButton;


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/ShareButton.js
// module id = 1607
// module chunks = 1